import React from 'react'

const Footer = () => (
    <div style={{ padding: '30px 0 20px 0' }}>
        <span style={{ fontSize: '50%' }}>
            made with&nbsp;
            <a href='https://www.linkedin.com/company/fractal-strategies/about/'>
                &#9829; in chicago
            </a>
        </span>
    </div>
)

export default Footer
